<template>
    <v-container class="grey lighten-5" fluid>
        <v-row>
            <!-- Merchant -->
            <v-col md="2">
                <v-autocomplete
                    v-model="search.merchant"
                    dense
                    :items="merchants"
     
                    label="Select a merchant"
                    append-icon="mdi-magnify"
                    class="mt-0 pt-0"
                    @change="getChargebacks"
                    clearable
                ></v-autocomplete>
            </v-col>

            <!-- Clearing Institutes -->
            <v-col md="2">
                <v-select
                    v-model="search.clearingInstitute"
                    dense
                    :items="clearingInstitutes"
                    label="Clearing Institutes"
                    append-icon="mdi-magnify"
                    class="mt-0 pt-0"
                    @change="getChargebacks"
                    clearable
                ></v-select>
            </v-col>

            <!-- ARN -->
            <v-col md="2">
                <v-text-field
                    v-model="search.arn"
                    append-icon="mdi-magnify"
                    label="ARN"
                    clearable
                    class="mt-0 pt-0"
                    @change="getChargebacks"
                    @click:clear="search.arn = null; getChargebacks();"
                ></v-text-field>
            </v-col>

            <!-- UUID -->
            <v-col md="2">
                <v-text-field
                    v-model="search.uuid"
                    append-icon="mdi-magnify"
                    label="UUID"
                    clearable
                    class="mt-0 pt-0"
                    @change="getChargebacks"
                    @click:clear="search.uuid = null; getChargebacks();"
                ></v-text-field>
            </v-col>

            <!-- From Date -->
            <v-col md="2">
                <v-menu
                    v-model="fromDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                ><template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="search.fromDate"
                        label="From Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="mt-0 pt-0"
                    ></v-text-field
                ></template>
                    <v-date-picker
                        v-model="search.fromDate"
                        @input="fromDateModal = false"
                        @click:date="handleDateFilters"
                    ></v-date-picker>
                </v-menu>
            </v-col>

            <!-- To Date -->
            <v-col md="2">
                <v-menu
                    v-model="toDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                ><template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="search.toDate"
                        label="To Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="mt-0 pt-0"
                    ></v-text-field
                ></template>
                    <v-date-picker
                        v-model="search.toDate"
                        @input="toDateModal = false"
                        @click:date="handleDateFilters"
                    ></v-date-picker>
                </v-menu>
            </v-col>
        </v-row>

        <v-row>
            <v-col align="end" class="py-0">
                <v-btn
                    small
                    dark
                    color="primary"
                    class="mb-3"
                    @click="download"
                    ><v-icon>mdi-arrow-down-bold</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        
        <v-col md="12" class="pt-0 px-0 caption stats justify-end">
            <v-btn x-small color="primary" dark tile class="elevation-0">
                <v-icon class="px-1" small color="white">mdi-sigma</v-icon>Total number of chargebacks: {{ total }}
            </v-btn>
        </v-col>
       
        <!-- Chargebacks Table -->
        <v-data-table
            :headers="tableHeaders"
            :items="tableData"
            :items-per-page="10"
            :loading="loading"
            class="elevation-1"
        >
            <template v-slot:item.post_date="{ item }">
                {{ formatPostDate(item.post_date) }}
            </template>
            <template v-slot:item.transaction.bin="{ item }">
                <span v-if="item.transaction">
                    {{ `${item.transaction.bin}******${item.transaction.last4Digits}` }}
                </span>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
    data() {
        return {
            tableHeaders: [{ text: 'Post Date', value: 'post_date', sortable: false, width: 120 },
                           { text: 'ARN', value: 'arn', sortable: false },
                           { text: 'Case Ref', value:'case_ref', sortable: false, width: 120 },
                           { text: 'Reason Code', value:'reason_code', sortable: false, align: 'center', width: 120 },
                           { text: 'Clearing Institute', value: 'acquirer', sortable: false, width: 150 },
                           { text: 'Merchant ID', value: 'merchant_id', sortable: false, width: 120 },
                           { text: 'Type', value: 'type', sortable: false },
                           { text: 'Amount', value: 'amount', sortable: false, align: 'center' },
                           { text: 'Currency', value: 'currency', sortable: false, align: 'center' },
                           { text: 'UUID', value: 'uuid', sortable: false },
                           { text: 'Merchant', value: 'transaction.merchantName', sortable: false, width: 150 },
                           { text: 'Channel', value: 'transaction.channelName', sortable: false, width: 200 },
                           { text: 'Card Holder', value: 'transaction.holder', sortable: false, width: 150 },
                           { text: 'Card No.', value: 'transaction.bin', sortable: false }],
            tableData: [],
            merchants: [],
            fromDateModal: false,
            toDateModal: false,
            clearingInstitutes: [{ value: 'Bambora (via Evry)', text: 'Bambora (via Evry)' },
                                 { value: 'Concardis', text: 'Concardis' },
                                 { value: 'Securetrading_Omnipay', text: 'Securetrading_Omnipay' },
                                 { value: 'Worldline', text: 'Worldline' }],
            search: { merchant: null,
                      clearingInstitute: null,
                      arn: null,
                      uuid: null,
                      fromDate: moment().startOf('month').format('YYYY-MM-DD'),
                      toDate: new Date().toISOString().substr(0, 10)
            },
            loading: false,
        }
    },
    beforeMount() {
        this.getChargebacks();
    },
    computed: {
        
    },
    methods: {
        getChargebacks() {
            if(this.$store.state.user.user_role.id <= 3) {
                this.master();
                this.loading = true;
            }
            else {
                this.client();
                this.loading = true;
            }
        },
        master() {
            axios({
            method: 'post',
            url: 'get-chargebacks',
            data: { search: this.search },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                console.log(response.data);
                this.tableData = response.data;
                this.loading = false;
                this.total = response.data.length;

                let arr = [];
                response.data.map(item => {
                    if(item.transaction !==  null) {
                        arr.push({ value: item.transaction.merchantUuid, text: item.transaction.merchantName });
                    }
                });
                this.merchants = arr.reduce((unique, o) => {
                    if(!unique.some(obj => obj.label === o.label && obj.value === o.value)) {
                    unique.push(o);
                    }
                    return unique;
                },[]);

                this.merchants.sort((a, b) => a.text.localeCompare(b.text));
             
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        client() {
            axios({
            method: 'post',
            url: 'get-transactions-live-client',
            data: { userId: this.$store.state.user.id, search: this.search },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.tableData = response.data;
                this.loading = false;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        formatPostDate(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        handleDateFilters() {
            if(this.search.toDate < this.search.fromDate) {
                this.search.fromDate = this.search.toDate;
            }
            this.getChargebacks();
        },
        download() {
            if(this.$store.state.user.user_role.id <= 3) {
                axios({
                    method: 'post',
                    url: 'download-chargebacks-report',  
                    data: { search: this.search },              
                    responseType: 'blob',
                    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                    })
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'chargebacks-report.csv');
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch(e => {
                        this.errors.push(e)
                })
            }
            else {
                axios({
                    method: 'post',
                    url: 'download-chargebacks-report-client',  
                    data: { userId: this.$store.state.user.id, search: this.search },              
                    responseType: 'blob',
                    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                    })
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'chargebacks-report.csv');
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch(e => {
                        this.errors.push(e)
                })
            }
        }
    }
}
</script>

<style>
    .v-data-table td {
        font-size: 0.6rem !important;
    }

    .stats {
        display: inline-flex;
        vertical-align: middle;
        align-items: center;
    }
</style>